import React, {useState} from "react";
import { Upload } from "antd";
import { uploadImageAndInsert } from "../../utils/uploadImageAndInsert";
import KoIcon from '@kwapio/icons';
import KoButton from "packages/button";
import KoLoader from "packages/loader";


export const UploadImageButton = ({ editor, onUpdateAttachment, lookupId, workspaceId, commentId, folderId, disabled }) => {
  const [loading, setLoading] = useState(false);
  const beforeUpload = async(file) => {
    await uploadImageAndInsert(editor, file, onUpdateAttachment, lookupId, workspaceId, commentId, setLoading, folderId);
    return false;
  };

  return (
    <>
      {loading&& <KoLoader/>}
      <Upload
        beforeUpload={beforeUpload}
        showUploadList={false}
        disabled={disabled}
        accept="image/*"
      >
        <KoButton type="text"  disabled={disabled} iconBtn icon={<KoIcon width={20} height={20} name="ImagesOutlined" />}/>
      </Upload>
    </>
  );
};